// Generated by ReScript, PLEASE EDIT WITH CARE


var identifiers = {
  imageElement: "image-element",
  trailerButton: "trailer-button",
  videoContainer: "video-container"
};

export {
  identifiers ,
}
/* No side effect */
